import React from "react";
import { InvoiceLinkRenderer } from "../../invoice/grid/cellRenderers.component";
import { buildInvoiceNumberWithBeer } from "utilities/dist/invoice/helpers";

export const ReferenceRenderer = ({ value, data }) => {
    if (!data) return null;
    if (data.invoice_id) {
        return <InvoiceLinkRenderer value={buildInvoiceNumberWithBeer(data.invoice)} data={data} />;
    }
    return value ? `Ref: ${value}` : "No Reference";
};
